module.exports = "/public/webpack/img/icon_help_feedback9c0207c3077672174badfac83529aebb.png";